// src/utils/isSameMonth.js
export function isSameMonth(date, comparison) {
  if (!date || !comparison) return false;

  // ensure both are Date objects
  const d1 = date instanceof Date ? date : new Date(date);
  const d2 = comparison instanceof Date ? comparison : new Date(comparison);

  return d1.getFullYear() === d2.getFullYear() && d1.getMonth() === d2.getMonth();
}
